import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { CompagineSocialeDto } from '@ideapa/common-dto';
import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class CompagineSocialeApiClient extends BaseCRUDApiClient<CompagineSocialeDto> {
  baseUrl = this.config.apiEndpoint + '/compagine-sociale';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getAllByPartecipata(idPartecipata: number) {
    return this.http.get<CompagineSocialeDto[]>(
      this.baseUrl + '/idPartecipata/' + idPartecipata
    );
  }
}
